import { render } from "./system-image.vue?vue&type=template&id=248e211c&scoped=true&ts=true"
import script from "./system-image.vue?vue&type=script&lang=ts"
export * from "./system-image.vue?vue&type=script&lang=ts"

import "./system-image.vue?vue&type=style&index=0&id=248e211c&lang=scss&scoped=true"

import exportComponent from "D:\\shine\\shine-project\\dispatch-big-screen-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-248e211c"]])

export default __exports__